import React from 'react';
import { Phone, Loader2 } from 'lucide-react';

const CallButton = ({ onClick, disabled, otherParticipantName, rtcStatus }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        relative px-8 py-4 rounded-2xl font-medium transition-all duration-300
        shadow-lg hover:shadow-xl hover:scale-105 active:scale-95
        disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:shadow-lg
        ${!otherParticipantName || rtcStatus === 'connecting'
          ? 'bg-gradient-to-r from-gray-700 to-gray-800'
          : 'bg-gradient-to-r from-emerald-500 via-green-500 to-teal-500 hover:from-emerald-600 hover:via-green-600 hover:to-teal-600'
        }
      `}
    >
      {/* Glow effect for active state */}
      {otherParticipantName && rtcStatus !== 'connecting' && (
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-emerald-400/20 via-green-400/20 to-teal-400/20 animate-pulse"></div>
      )}

      <div className="relative z-10 flex items-center gap-3">
        {rtcStatus === 'connecting' ? (
          <>
            <div className="relative">
              <Loader2 className="w-6 h-6 text-white animate-spin"/>
              <div className="absolute inset-0 animate-ping bg-white/20 rounded-full"></div>
            </div>
            <span className="text-white text-lg font-semibold">Connecting...</span>
          </>
        ) : (
          <>
            <div className="relative">
              <Phone className="w-6 h-6 text-white"/>
              {/* Ringing animation effect */}
              <div className="absolute inset-0 animate-ping bg-emerald-400/30 rounded-full"></div>
            </div>
            <div className="text-left">
              <div className="text-white text-lg font-semibold">
                Call {otherParticipantName || 'Participant'}
              </div>
              <div className="text-emerald-200/80 text-sm">
                Start voice conversation
              </div>
            </div>
          </>
        )}
      </div>

      {/* Status indicator */}
      {!otherParticipantName && (
        <div className="absolute -top-2 -right-2 w-4 h-4 rounded-full bg-yellow-500 border-2 border-gray-900 animate-pulse"></div>
      )}
    </button>
  );
};

export default CallButton;
